import { KMSClient } from '@aws-sdk/client-kms';
import { getKMSKeys } from 'lib/utils';

const { accessKey, secretAccessKey, decryptAccessKey, decryptSecretAccessKey } =
  getKMSKeys();

export const encryptionClient = new KMSClient({
  // region: process.env.REACT_APP_KMS_REGION,
  region: process.env.REACT_APP_MX_KMS_REGION,
  credentials: {
    accessKeyId: accessKey,
    secretAccessKey: secretAccessKey,
  },
});

export const decryptionClient = new KMSClient({
  // region: process.env.REACT_APP_KMS_REGION,
  region: process.env.REACT_APP_MX_KMS_REGION,
  credentials: {
    accessKeyId: decryptAccessKey,
    secretAccessKey: decryptSecretAccessKey,
  },
});
